import api from "./axiosInstance";

// GET /dashboard/contextInsights?start=&end=&top_k=
export async function getContextInsights(params) {
	const { start, end, top_k = 10 } = params || {};
	const { data } = await api.get("/dashboard/contextInsights", {
		params: { start, end, top_k }
	});
	return data;
}


